import React from "react";
import { Modal, Button, Spinner } from "react-bootstrap";
import { AlertTriangle } from "react-feather";

export default function ConfirmModal({
  show,
  title = "Confirm",
  message = "Are you sure?",
  confirmText = "Yes, Confirm",
  cancelText = "Cancel",
  variant = "danger",
  loading = false,
  onCancel,
  onConfirm,
}) {
  return (
    <Modal show={show} onHide={onCancel} centered backdrop="static" keyboard={!loading}>
      <Modal.Header closeButton={!loading} style={{ borderBottom: "1px solid #e5e7eb" }}>
        <Modal.Title style={{ fontWeight: 900, fontSize: "1.1rem" }}>
          {title}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="py-4">
        <div className="d-flex align-items-start gap-3">
          <div
            style={{
              width: 42,
              height: 42,
              borderRadius: 12,
              background: "#FEF3C7",
              display: "grid",
              placeItems: "center",
              flex: "0 0 auto",
            }}
          >
            <AlertTriangle size={22} color="#92400e" />
          </div>

          <div>
            <div style={{ fontWeight: 700, marginBottom: 6 }}>{message}</div>
            <div className="text-muted small">
              This action cannot be undone.
            </div>
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer style={{ borderTop: "1px solid #e5e7eb" }}>
        <Button variant="outline-secondary" onClick={onCancel} disabled={loading}>
          {cancelText}
        </Button>

        <Button variant={variant} onClick={onConfirm} disabled={loading}>
          {loading ? (
            <>
              <Spinner size="sm" animation="border" className="me-2" />
              Please wait...
            </>
          ) : (
            confirmText
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
